import { DatePicker, Form, Input, InputNumber } from 'antd'
import dayjs from 'dayjs'
import React, { useState } from 'react'
import { $t } from '~/i18n.js'
import { DataCard } from "~/components/dataCards/dataCard.jsx";
import { KNVVLStatus } from '~/components/profile/tabs/KNVVLComponents.jsx';
import { HelpBubble } from '~/components/help/helpBubble.jsx';

export const CardBrevetPermissions = ({profile, club}) => {
  const is_instructeur = profile.is_instructeur
  const is_brevet = profile.group_keys?.indexOf('brevet') > -1
  const is_technicus = profile.group_keys?.includes('technicus_vliegend') || profile.group_keys?.includes('technicus_arc')
  
  const is_nl = club?.association === 'knvvl'

  return {
    is_instructeur,
    is_brevet,
    is_technicus,
    is_nl,
    hideBrevetCard: !is_brevet && !is_instructeur && !is_nl && !is_technicus
  }
}

export const CardBrevet = ({ profile, gegevens, club, saveData, type, readOnly, onChange }) => {
  const [loading, setLoading] = useState(false)
  const [form] = Form.useForm()

  const saveForm = async () => {
    try {
      setLoading(true)
      const values = await form.validateFields()
      const date_brevet_afgifte = values.date_brevet_afgifte ? values.date_brevet_afgifte.format('YYYY-MM-DD') : null

      // for now fis dates are setup by backend
      // let fis_date_refresher_course = values.fis_date_refresher_course ? values.fis_date_refresher_course.format('YYYY-MM-DD') : null;
      // let fis_date_training_flight = values.fis_date_training_flight ? values.fis_date_training_flight.format('YYYY-MM-DD') : null;
      const fis_initial_hours = values.fis_initial_hours
      const knvvl = values.knvvl
      const brevet_nummer = values.brevet_nummer
      const aml_nummer = values.aml_nummer

      // manipulate values for save
      const res = await saveData({
        gegevens: { date_brevet_afgifte, fis_initial_hours, knvvl, brevet_nummer, aml_nummer }
      })
      setLoading(false)
      return res
    } catch (info) {
      console.log('Validate Failed:', info)
      setLoading(false)
    }
  }

  const {
    is_instructeur,
    is_brevet,
    is_technicus,
    is_nl
  } = CardBrevetPermissions({ profile, club })

  return (
     <DataCard
      title={$t("brevet")}
      onSave={!readOnly && !onChange && saveForm}
      loading={loading}
      type={type}
    >
        <Form
          form={form}
          name="Brevet"
          labelCol={{ span: 8 }}
          wrapperCol={{ span: 14 }}
          initialValues={{
            date_brevet_afgifte:
              gegevens.date_brevet_afgifte &&
              dayjs(gegevens.date_brevet_afgifte, "YYYY-MM-DD"),
            fis_initial_hours: gegevens.fis_initial_hours,
            knvvl: gegevens.knvvl,
            brevet_nummer: gegevens.brevet_nummer,
            aml_nummer: gegevens.aml_nummer,
          }}
          requiredMark={false}
          onValuesChange={onChange ? (_, values) => {
            const date_brevet_afgifte = values.date_brevet_afgifte
              ? values.date_brevet_afgifte.format('YYYY-MM-DD')
              : null;
            onChange({
              gegevens: {
                date_brevet_afgifte,
                fis_initial_hours: values.fis_initial_hours,
                knvvl: values.knvvl,
                brevet_nummer: values.brevet_nummer,
                aml_nummer: values.aml_nummer,
              }
            });
          } : undefined}
        >
          {(is_instructeur || is_brevet) && (
            <>
              <Form.Item name="brevet_nummer" label={$t("(SPL) Brevet nummer")}>
                <Input placeholder={$t("Brevet nummer")} disabled={readOnly} />
              </Form.Item>
              
              <Form.Item label={$t('Datum brevet uitgifte')} name="date_brevet_afgifte" extra={!readOnly &&  $t(
                  "Staat op je brevet (onder punt X), vanaf deze datum berekent het systeem je rolling recency."
                )}>
                <DatePicker format={localStorage.localeFormat} disabled={readOnly} />
              </Form.Item>
            </>
          )}

          {is_technicus &&
              <Form.Item name="aml_nummer" label={$t("Technicus licentie (AML) nummer:")}>
                <Input placeholder={$t("AML nummer")} disabled={readOnly} />
              </Form.Item>
          }

          {is_nl && (
              <Form.Item name="knvvl" label={$t("KNVvL lidnummer")}>
                <Input disabled={readOnly} />
              </Form.Item>
          )}

          {is_nl && (
            <Form.Item label={<p>{$t("KNVvL status")} <HelpBubble content={$t('Status bij KNVvL. Bij geen data is geboortedatum of KNVvL nummer niet bekend. Data wordt elke nacht ververst.')}/></p>}>
              <KNVVLStatus association={profile.association} userGroups={profile.group_keys}/>
            </Form.Item>
          )}

          {is_instructeur && !readOnly && (
              <Form.Item
                label={$t("Start uren instructie FI(s)")}
                name="fis_initial_hours"
                rules={[{ required: false, message: $t("Vul in") }]}
                extra={!readOnly && <span>{$t('Optioneel')}:{" "}
                {$t(
                  "Nodig om je totaal FI(s) uur bij te werken met vluchten gemaakt in het verleden."
                )} {" "}
                {$t('Als je dit invult krijg je een "correcte" weergave van je totale instructieuren.')}</span>}
              >
                <InputNumber
                  min={0}
                  formatter={(value) => `${value} ${$t("uren")}`}
                  parser={(value) => value.replace(/\D/g, "")}
                />
              </Form.Item>
          )}
        </Form>
    </DataCard>
  );
}
